module.exports = __webpack_public_path__ + "static/media/globe-empty.6d6c44ca.png";